import { Component, Input, OnInit } from '@angular/core';
import { LabeledItem } from './item-label.interface';

@Component({
  selector: 'inventory-ui-item-label',
  templateUrl: './item-label.component.html',
  styleUrls: ['./item-label.component.scss'],
})
export class ItemLabelComponent implements OnInit {
  @Input() item?: LabeledItem;
  @Input() showItemId = true;
  @Input() showEditionName = true;
  @Input() showStatus = false;

  itemStatus = '';

  ngOnInit(): void {
    if (this.showStatus) {
      let statusKey = '';
      switch (this.item?.status) {
        case 'Pending':
          statusKey = 'ACTIVE_ITEMS.STATUS.PENDING';
          break;
        case 'Canceled':
          statusKey = 'ACTIVE_ITEMS.STATUS.CANCELED';
          break;
        case 'Demo':
          statusKey = 'ACTIVE_ITEMS.STATUS.DEMO';
          break;
        case 'Demo expired':
          statusKey = 'ACTIVE_ITEMS.STATUS.DEMO_EXPIRED';
          break;
      }
      this.itemStatus = statusKey;
    }
  }
}
